import React, { useContext, useEffect } from 'react';
import { createStyles, makeStyles, Theme } from '@material-ui/core/styles';
import clsx from 'clsx';

import EndCallButton from './EndCallButton/EndCallButton';
import CaptureButton from './CaptureButton/CaptureButton';
import RecordingButton from './RecordingButton/RecordingButton';
import ToggleAudioButton from './ToggleAudioButton/ToggleAudioButton';
import ToggleVideoButton from './ToggleVideoButton/ToggleVideoButton';
import ToggleScreenShareButton from './ToogleScreenShareButton/ToggleScreenShareButton';

import useIsUserActive from './useIsUserActive/useIsUserActive';
import useRoomState from '../../hooks/useRoomState/useRoomState';
import { MeetingContext } from '../../App';
import ToggleAnnotateButton from './ToggleAnnotateButton/ToggleAnnotateButton';
import useVideoContext from '../../hooks/useVideoContext/useVideoContext';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    container: {
      display: 'flex',
      position: 'absolute',
      right: '50%',
      transform: 'translate(50%, 30px)',
      bottom: '50px',
      zIndex: 1000,
      transition: 'opacity 1.2s, transform 1.2s, visibility 0s 1.2s',
      opacity: 0,
      visibility: 'hidden',
      maxWidth: 'min-content',
      '&.showControls, &:hover': {
        transition: 'opacity 0.6s, transform 0.6s, visibility 0s',
        opacity: 1,
        visibility: 'visible',
        transform: 'translate(50%, 0px)',
      },
      [theme.breakpoints.down('xs')]: {
        bottom: `${theme.sidebarMobileHeight + 3}px`,
      },
    },
  })
);

export default function Controls() {
  const classes = useStyles();
  const roomState = useRoomState();
  const isReconnecting = roomState === 'reconnecting';
  const isUserActive = useIsUserActive();
  const showControls = isUserActive || roomState === 'disconnected';
  const { userType, isMobile } = useContext(MeetingContext);
  const { setHasMainVideo, trackDetached } = useVideoContext();

  useEffect(() => {
    const timer = setTimeout(() => {
      var mainVideoContainer = document.getElementById('main-container');
      if (mainVideoContainer) {
        let video = mainVideoContainer.getElementsByTagName('video')[0] as any;
        if (video) setHasMainVideo(true);
        else setHasMainVideo(false);
      }
    }, 100);
    return () => {
      clearTimeout(timer);
    };
  }, [trackDetached]);

  return (
    <div className={clsx(classes.container, { showControls })}>
      {roomState !== 'disconnected' && (
        <>
          <ToggleAudioButton disabled={isReconnecting} />
          <ToggleVideoButton disabled={isReconnecting} />
          <ToggleScreenShareButton disabled={isReconnecting} />
          {userType !== 'guest' ? (
            <>
              <CaptureButton />
              <ToggleAnnotateButton />
              <RecordingButton />
            </>
          ) : null}
          <EndCallButton userType={userType} />
        </>
      )}
    </div>
  );
}
